<ng-container>
  <aside *ngIf="!loading; else loadingContent">
    <h2 class="redeem-cash-information-title">
      {{
        'redeem_cash.checkout.information-title'
          | translate
            : {
                loyaltyCurrency: loyaltyCurrencySelected.shortName
              }
      }}
    </h2>
    <div
      class="redeem-cash-information-content"
      [innerHtml]="
        'redeem_cash.checkout.information-content' | translate
      "></div>
  </aside>

  <ng-template #loadingContent>
    <div class="redeem-cash-information-container">
      <span class="redeem-cash-information-title loading"></span>
      <span class="redeem-cash-information-content loading"></span>
    </div>
  </ng-template>
</ng-container>
